import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'

import { IDocumentHeadProps } from './DocumentHead.types'

import { appConfig } from '@/config/app'
import { privateRoutes } from '@/router/routes/private.routes'
import { publicRoutes } from '@/router/routes/public.routes'

export const DocumentHead = ({
    title,
    description = 'Optimo - People Intelligence Platform for better workforce insights and management.',
    keywords = ['HR', 'People Analytics', 'Workforce Management', 'Employee Insights'],
}: IDocumentHeadProps) => {
    const location = useLocation()

    // Get current route from URL path
    const allRoutes = [...publicRoutes, ...privateRoutes]
    const currentRoute = allRoutes.find((r) => r.path === location.pathname)

    // Generate dynamic title
    const pageTitle = title || currentRoute?.title || 'Dashboard'
    const fullTitle = `${pageTitle} | ${appConfig.name}`

    // Update document title
    useEffect(() => {
        document.title = fullTitle
    }, [fullTitle])

    // Update meta tags
    useEffect(() => {
        // Description
        const metaDescription = document.querySelector('meta[name="description"]')
        if (metaDescription) {
            metaDescription.setAttribute('content', description)
        } else {
            const meta = document.createElement('meta')
            meta.name = 'description'
            meta.content = description
            document.head.appendChild(meta)
        }

        // Keywords
        const metaKeywords = document.querySelector('meta[name="keywords"]')
        const keywordsContent = keywords.join(', ')
        if (metaKeywords) {
            metaKeywords.setAttribute('content', keywordsContent)
        } else {
            const meta = document.createElement('meta')
            meta.name = 'keywords'
            meta.content = keywordsContent
            document.head.appendChild(meta)
        }

        // Viewport (ensure it's set)
        if (!document.querySelector('meta[name="viewport"]')) {
            const viewport = document.createElement('meta')
            viewport.name = 'viewport'
            viewport.content = 'width=device-width, initial-scale=1.0'
            document.head.appendChild(viewport)
        }

        // Theme color
        const themeColor = document.querySelector('meta[name="theme-color"]')
        if (themeColor) {
            themeColor.setAttribute('content', '#5E4AE3')
        } else {
            const meta = document.createElement('meta')
            meta.name = 'theme-color'
            meta.content = '#5E4AE3'
            document.head.appendChild(meta)
        }
    }, [description, keywords])

    return null // This component doesn't render anything
}
